function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import moduleStyles from '@dtsl/css-card/dist/index.module.css';
function CardWrapper(props) {
  const {
    url,
    styles,
    target,
    onClick,
    variant,
    disabled,
    children,
    className,
    direction,
    dataTestId,
    isSelected,
    percentage,
    columnReverse,
    customCard,
    ...restProps
  } = props;
  const isClickable = variant === 'clickable';
  {
    const cardClassName = classNames({
      [moduleStyles['sib-card']]: true,
      [moduleStyles['sib-card--clickable']]: isClickable,
      [moduleStyles['sib-card-selected']]: isSelected,
      [moduleStyles['sib-card--custom']]: customCard,
      [className]: !!className
    });
    const gridStyles = {};
    if (!customCard) {
      if (percentage >= 0) {
        if (direction === 'row') {
          gridStyles.gridTemplateRows = `${percentage}% ${100 - percentage}%`;
          gridStyles.gridTemplateColumns = '100%';
        } else {
          gridStyles.gridTemplateColumns = `${percentage}% ${100 - percentage}%`;
          gridStyles.gridTemplateRows = '100%';
          gridStyles.direction = columnReverse ? 'rtl' : 'ltr';
        }
      }
    }
    const handleClick = e => {
      if (url === '#' && !customCard) {
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();
      }
      onClick(e);
    };
    const defaultCardStyles = {
      height: '227px',
      width: '400px'
    };
    const cardStyles = {
      ...(!customCard ? defaultCardStyles : {}),
      // Apply defaultCardStyles when customCard is false
      ...gridStyles,
      ...styles
    };
    if (isClickable) {
      if (url && url !== '#') {
        return /*#__PURE__*/React.createElement("a", _extends({
          rel: "noreferrer",
          target: target,
          disabled: disabled,
          onClick: handleClick,
          className: cardClassName,
          href: disabled ? null : url,
          role: disabled ? 'link' : null,
          style: cardStyles,
          "aria-disabled": disabled ? 'true' : null,
          "data-testid": dataTestId ? dataTestId : null
        }, restProps), children);
      } else {
        return /*#__PURE__*/React.createElement("div", _extends({}, restProps, {
          className: cardClassName,
          "data-testid": dataTestId ? dataTestId : null,
          disabled: disabled,
          "aria-disabled": disabled ? 'true' : null,
          onClick: handleClick,
          role: "button",
          onKeyDown: handleClick,
          tabIndex: "0",
          style: cardStyles
        }), children);
      }
    }
    return /*#__PURE__*/React.createElement("div", {
      className: cardClassName,
      "data-testid": dataTestId ? dataTestId : null,
      style: cardStyles
    }, children);
  }
}
const Card = /*#__PURE__*/React.forwardRef(function Card(props, ref) {
  // eslint-disable-next-line react/prop-types
  const {
    children,
    ...cardProps
  } = props;
  return /*#__PURE__*/React.createElement(CardWrapper, _extends({}, cardProps, {
    ref: ref
  }), children);
});
function CardImage(props) {
  const {
    children,
    className,
    ...restProps
  } = props;
  const imageClass = classNames({
    [moduleStyles['sib-card__image']]: true,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: imageClass
  }, restProps), children);
}
function CardContent(props) {
  const {
    className,
    children,
    ...restProps
  } = props;
  const cardContentClass = classNames({
    [moduleStyles['sib-card__content']]: true,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cardContentClass
  }, restProps), children);
}
Card.Content = CardContent;
Card.Image = CardImage;
CardContent.defaultProps = {
  className: '',
  children: null
};
CardContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
Card.propTypes = {
  children: PropTypes.node.isRequired
};
CardImage.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
CardImage.defaultProps = {
  className: '',
  children: null
};
CardWrapper.defaultProps = {
  direction: 'column',
  className: '',
  styles: {},
  url: '#',
  content: null,
  disabled: false,
  dataTestId: null,
  onClick: () => {},
  variant: '',
  isSelected: false,
  percentage: 0,
  target: '_self',
  columnReverse: false,
  customCard: false
};
CardWrapper.propTypes = {
  styles: PropTypes.object,
  url: PropTypes.string,
  content: PropTypes.node,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  variant: PropTypes.oneOf(['default', '', 'clickable']),
  children: PropTypes.node,
  direction: PropTypes.oneOf(['row', 'column']),
  columnReverse: PropTypes.bool,
  percentage: PropTypes.number,
  target: PropTypes.string,
  isSelected: PropTypes.bool,
  customCard: PropTypes.bool
};
export default Card;